import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { compose } from '../../../../services/utilityFunctions';
import FormSubtitle from '../../../../commonComponents/forms/FormSubtitle';
import ConnectorCalendly from './singleConnectors/calendly/ConnectorCalendly';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';

const CONNECTORS = {
  CALENDLY: 'calendly',
};

const renderConnector = (connectors, connectorType, tenant, organization) => {
  switch (connectorType) {
    case CONNECTORS.CALENDLY:
      return (
        <div className="connector-card card">
          <ConnectorCalendly
            calendlyService={connectors.calendly}
            tenant={tenant}
            organization={organization}
          />
        </div>
      );
    default:
      return null;
  }
};

function Connectors({ t, member }) {
  const { organization, tenant } = useContext(ConfigsContext);

  const { connectors } = member;

  return (
    <div className="connectors-container">
      <FormSubtitle title={t('profile.connectors.tab.title')} />
      <div className="row">
        {Object.values(CONNECTORS).map(connectorType => (
          <div className="col-lg-4 col-md-5 col-12" key={connectorType}>
            {renderConnector(connectors, connectorType, tenant, organization)}
          </div>
        ))}
      </div>
    </div>
  );
}

Connectors.propTypes = {
  /** translation function */
  t: PropTypes.func.isRequired,
  member: PropTypes.shape(UserProp.propType).isRequired,
};

export default compose(translate)(Connectors);
